import Content from "@/components/Content.tsx";
import Header from "@/Header.tsx";
import User_UpcomingGames from "@/user/User_UpcomingGames.tsx";
import {createFileRoute} from '@tanstack/react-router'
import React from "react";

export const Route = createFileRoute('/_app/profile/upcoming-games')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>
        <Header />
        <Content>
            <User_UpcomingGames />
        </Content>
    </>
}
